import React from 'react';
import './best-score.scss';

const BestScore = ({ bestScore }) => {
    return (
        <div className="best_score">
            <div className="best_third">
                <div className="best_second">
                    <div className="best_yellow">
                        <div className="score_end">
                            <span className="best_score_title">Best score</span>
                            <span className="best_score_number">
                                {bestScore}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BestScore;
